export default __webpack_public_path__ + "static/media/email-error.e30b2c0a.svg";